/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedCompromisedDevice
 */
export interface PatchedCompromisedDevice {
    /**
     * 
     * @type {number}
     * @memberof PatchedCompromisedDevice
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedCompromisedDevice
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCompromisedDevice
     */
    stealerType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCompromisedDevice
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCompromisedDevice
     */
    os?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCompromisedDevice
     */
    ip?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedCompromisedDevice
     */
    infectionDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCompromisedDevice
     */
    zipFile?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedCompromisedDevice
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedCompromisedDevice
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PatchedCompromisedDevice
     */
    readonly leaks?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCompromisedDevice
     */
    readonly leaksCount?: string;
}

/**
 * Check if a given object implements the PatchedCompromisedDevice interface.
 */
export function instanceOfPatchedCompromisedDevice(value: object): value is PatchedCompromisedDevice {
    return true;
}

export function PatchedCompromisedDeviceFromJSON(json: any): PatchedCompromisedDevice {
    return PatchedCompromisedDeviceFromJSONTyped(json, false);
}

export function PatchedCompromisedDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedCompromisedDevice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'deviceId': json['device_id'] == null ? undefined : json['device_id'],
        'stealerType': json['stealer_type'] == null ? undefined : json['stealer_type'],
        'country': json['country'] == null ? undefined : json['country'],
        'os': json['os'] == null ? undefined : json['os'],
        'ip': json['ip'] == null ? undefined : json['ip'],
        'infectionDate': json['infection_date'] == null ? undefined : (new Date(json['infection_date'])),
        'zipFile': json['zip_file'] == null ? undefined : json['zip_file'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'leaks': json['leaks'] == null ? undefined : json['leaks'],
        'leaksCount': json['leaks_count'] == null ? undefined : json['leaks_count'],
    };
}

  export function PatchedCompromisedDeviceToJSON(json: any): PatchedCompromisedDevice {
      return PatchedCompromisedDeviceToJSONTyped(json, false);
  }

  export function PatchedCompromisedDeviceToJSONTyped(value?: Omit<PatchedCompromisedDevice, 'id'|'created_at'|'updated_at'|'leaks'|'leaks_count'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_id': value['deviceId'],
        'stealer_type': value['stealerType'],
        'country': value['country'],
        'os': value['os'],
        'ip': value['ip'],
        'infection_date': value['infectionDate'] == null ? undefined : ((value['infectionDate'] as any).toISOString()),
        'zip_file': value['zipFile'],
    };
}

